<header class="ion-header ion-hide-lg-up">
  <header-main></header-main>
  <div class="ion-fab">
    <div class="ion-fab-button close button-tertiary button-round">
      <a href="/promote">
        <img class="ion-icon" src="assets/icons/close.svg">
      </a>
    </div>
  </div>
</header>

<main class="ion-content" *ngIf="ad" fullscreen class="p">
  <header class="ion-hide-lg-down">
    <header-desktop></header-desktop>
    <h1>
      <svg class="ion-icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 26.03 26.17"><defs><style>.promote{stroke:none;}</style></defs><title>promote</title><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path class="promote" d="M17,12.78A7,7,0,1,0,6.7,10.06a7.56,7.56,0,0,0,1.08,1.61,7.44,7.44,0,0,0,1.27,1.11A13,13,0,0,0,0,25.17a1,1,0,0,0,1,1H18.49a1,1,0,0,0,0-2H2a11,11,0,0,1,22,1,1,1,0,0,0,2,0A13,13,0,0,0,17,12.78ZM8,7a5,5,0,1,1,1.26,3.32A5.19,5.19,0,0,1,8.5,9.19,5,5,0,0,1,8,7Z"></path></g></g></svg>
      {{ad.title}}
    </h1>
  </header>
  <div class="container-fluid">
    <div class="row">
      <div class="col col-xs-12 col-md-10 col-lg-8 col-xl-6 col-md-offset-1 col-lg-offset-2 col-xl-offset-3">
        <div class="ion-card detail ion-margin ion-padding">
          <div class="ion-card-content ion-padding">
            <div class="ion-card-title">{{ad.title}}</div>
            <div class="subtitle">
              <span class="location ion-padding-end">
                <img *ngIf="ad.country" class="ion-icon" src="assets/flags/{{ad.country | lowercase}}.svg"/>
                <ng-container *ngIf="ad.location == 'onsite'">
                  <ng-container *ngIf="ad.suburb || ad.city">{{ad.suburb}} {{ad.city}}</ng-container>
                  <ng-container *ngIf="!(ad.suburb || ad.city)">{{directory_data.name}}</ng-container>
                </ng-container>
                <ng-container *ngIf="ad.location == 'remote'">Remote</ng-container>
              </span>
              <span><img class="ion-icon" src="assets/icons/star.svg"/></span>
              <span *ngIf="ad.alias"><span class="ion-hide-sm-down">Posted By </span>{{ad.alias}}</span>
              <span *ngIf="ad.rating" class="ion-hide-sm-down"> - {{ad.rating | number:'1.0-0'}} star ad lister</span>
            </div>
            <youtube-player *ngIf="ad.video && ad.video.indexOf('@') === -1 && ad.video.indexOf('channel') === -1 && ad.video.indexOf('playlist') === -1 && ad.video.indexOf('fb.watch') === -1 && ad.video.indexOf('vimeo') === -1" [vid]="ad.video"></youtube-player>
            <div class="container-fluid">
              <div class="row">
                <div class="col col-xs-12 col-sm-7 ion-no-padding details">
                  <div class="ion-card-subtitle">Details</div>
                  <p>{{ad.overview}}</p>
                  <div class="ion-card-subtitle">Location</div>
                  <p *ngIf="ad.location == 'remote'">Remote</p>
                  <ng-container *ngIf="ad.location == 'onsite'">
                    <p *ngIf="ad.suburb">{{ad.suburb}}</p>
                    <p *ngIf="ad.city">{{ad.city}}</p>
                    <p *ngIf="ad.region">{{ad.region}}</p>
                  </ng-container> 
                  <div class="ion-card-subtitle">Published</div>
                  <ng-container *ngIf="(ad.grouping | type) === 'string'">
                    <p *ngIf="ad.grouping">{{ad.grouping}} - {{ad.classification}}</p>
                  </ng-container>
                  <ng-container *ngIf="(ad.grouping | type) === 'object'">
                    <p *ngFor="let group of ad.grouping; let i = index">in {{group}} - {{ad.classification[i]}}</p>
                  </ng-container>
                  <p *ngIf="ad.company">by {{ad.company}}</p>
                  <div class="ion-card-subtitle">Ad Targeting</div>
                  <a *ngIf="ad.all && ad.country !== 'GB'" href="https://{{ad.country | lowercase}}.gigexchange.com/location/{{directory_data.slug}}"><button class="button-round button-small button-solid button-ultra-violet ion-chip">All of {{ad.country}}</button></a>
                  <a *ngIf="ad.all && ad.country == 'GB'" href="https://{{directory_data.slug}}.gigexchange.com/location/{{directory_data.slug}}"><button class="button-round button-small button-solid button-ultra-violet ion-chip">All of {{directory_data.slug | uppercase}}</button></a>
                  <ng-container *ngIf="!ad.all && ad.country !== 'GB'">
                    <a *ngIf="!ad.cities && !ad.regions" href="https://{{ad.country | lowercase}}.gigexchange.com/location/{{directory_data.slug}}"><button class="button-round button-small button-solid button-ultra-violet ion-chip">All of {{ad.country}}</button></a>
                    <a *ngFor="let city of ad.cities" href="https://{{ad.country | lowercase}}.gigexchange.com/location/{{directory_data.slug}}/{{city | slugify}}"><button class="button-round button-small button-solid button-ultra-violet ion-chip">{{city}}</button></a>
                    <a *ngFor="let region of ad.regions" href="https://{{ad.country | lowercase}}.gigexchange.com/location/{{directory_data.slug}}/{{region | slugify}}"><button class="button-round button-small button-solid button-ultra-violet ion-chip">{{region}}</button></a>
                  </ng-container>
                  <ng-container *ngIf="!ad.all && ad.country == 'GB'">
                    <a *ngIf="!ad.cities && !ad.regions" href="https://{{directory_data.slug}}.gigexchange.com/location/{{directory_data.slug}}"><button class="button-round button-small button-solid button-ultra-violet ion-chip">All of {{directory_data.slug | uppercase}}</button></a>
                    <a *ngFor="let city of ad.cities" href="https://{{directory_data.slug}}.gigexchange.com/location/{{directory_data.slug}}/{{city | slugify}}"><button class="button-round button-small button-solid button-ultra-violet ion-chip">{{city}}</button></a>
                    <a *ngFor="let region of ad.regions" href="https://{{directory_data.slug}}.gigexchange.com/location/{{directory_data.slug}}/{{region | slugify}}"><button class="button-round button-small button-solid button-ultra-violet ion-chip">{{region}}</button></a>
                  </ng-container>
                </div>
                <div class="col col-xs-12 col-sm-5 ion-no-padding application">
                  <div class="apply-box">
                    <div class="ion-card-subtitle">Enquiries</div>
                    <h4>
                      {{directory_data.currency_symbol}}
                      <small>Negotiable</small>
                    </h4>
                    <ng-container *ngIf="!ad.complete && ad.visibility">
                      <ng-container *ngIf="auth.user | async as user; else guest;">
                        <apply-ad *ngIf="user.customer && user.uid != ad.customer" [customerid]="ad.customer" [adid]="ad.id" [title]="ad.title" [uid]="user.uid" apply="true"></apply-ad>
                        <ng-container *ngIf="!(user.customer)">
                          <p><button class="button-solid button-tertiary button-round" (click)="isApply=!isApply">Apply now</button></p>
                          <a *ngIf="user.welcome && isApply" href="/account/profile/"><button class="button-solid button-white button-round">Update profile</button></a>
                          <a *ngIf="!user.welcome && isApply" href="/account/profile/promote"><button class="button-solid button-white button-round">Update profile</button></a>
                        </ng-container>
                      </ng-container>
                      <ng-template #guest>
                        <p><button class="button-solid button-tertiary button-round" (click)="isApply=!isApply">Apply now</button></p>
                        <a *ngIf="isApply" href="/account/profile/promote"><button class="button-solid button-white button-round">Update profile</button></a>
                      </ng-template>
                    </ng-container>
                    <ng-container *ngIf="ad.complete || !ad.visibility">
                      <p><button class="button-solid button-secondary button-round ion-margin-top ion-margin-end ion-margin-bottom">Complete</button></p>
                    </ng-container>
                    <ng-container *ngIf="ad.contact || ad.phone || ad.url">
                      <hr>
                      <div class="ion-card-subtitle">Contact</div>
                      <p><strong *ngIf="ad.contact">e: <a [href]="'mailto:'+ad.contact+'?subject='+ad.title">{{ad.contact}}</a></strong></p>
                      <p><strong *ngIf="ad.phone">p: <a [href]="'tel:'+ad.phone">{{ad.phone}}</a></strong></p>
                      <p><strong *ngIf="ad.url">w: <a [href]="url" (click)="openExternalLink(url)">{{link}}</a></strong></p>
                      <p><strong *ngIf="ad.video.indexOf('@') !== -1">yt: <a [href]="ad.video" (click)="openExternalLink(ad.video)">{{ad.video.split('@')[1]}}</a></strong></p>
                      <p><strong *ngIf="ad.video.indexOf('/channel/') !== -1">yt: <a [href]="ad.video" (click)="openExternalLink(ad.video)">{{ad.video.split('/channel/')[1]}}</a></strong></p>
                    </ng-container>
                    <ng-container *ngIf="ad.logo">
                      <hr>
                      <img class="logo" [src]="bucketURL + ad.logo + '?alt=media'" [alt]="ad.company" onerror="this.style.display='none'" />
                    </ng-container>
                  </div>
                </div>
                <div class="col col-xs-12 ion-no-padding description">
                  <div class="ion-card-subtitle">Description</div>
                  <p class="description" [innerHTML]="ad.description"></p>
                </div>
                <div class="col col-xs-12 ion-no-padding gallery">
                  <image-gallery [customerid]="ad.customer" [adid]="ad.id"></image-gallery>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <feature-skills *ngIf="ad.country!=='GB'" [code]="ad.country" [country]="directory_data.name" [slug]="directory_data.slug" [grouping]="ad.grouping" [classification]="ad.classification" service="Small Businesses"></feature-skills>
  <feature-skills *ngIf="ad.country=='GB'" [code]="directory_data.slug" [country]="directory_data.name" [slug]="directory_data.slug" [grouping]="ad.grouping" [classification]="ad.classification" service="Small Businesses"></feature-skills>
  <footer class="ion-hide-lg-down">
    <footer-desktop></footer-desktop>
  </footer>
</main>

<footer class="ion-footer ion-hide-lg-up">
  <footer-main></footer-main>
</footer>